import { jwtDecode } from 'jwt-decode';
import TokenService from './tokenService';

/** Email that receives the Admin sidebar and routes (client-side check only). */
export const ADMIN_EMAIL = 'ashok@iissms.co.in';

const LOGIN_EMAIL_KEY = 'iissms_login_email';

export function setLoginEmailForSession(email) {
  if (typeof email === 'string' && email.trim()) {
    localStorage.setItem(LOGIN_EMAIL_KEY, email.toLowerCase().trim());
  }
}

export function clearLoginEmailForSession() {
  localStorage.removeItem(LOGIN_EMAIL_KEY);
}

function decodeEmailFromToken(token) {
  if (!token) return '';
  try {
    const d = jwtDecode(token);
    const candidates = [d.email, d.userEmail, d.user_email, d.username];
    for (const c of candidates) {
      if (typeof c === 'string' && c.includes('@')) return c.toLowerCase().trim();
    }
    if (typeof d.sub === 'string' && d.sub.includes('@')) return d.sub.toLowerCase().trim();
  } catch {
    /* ignore */
  }
  return '';
}

/** Resolved session email: JWT claim first, then email stored at login. */
export function getSessionEmail() {
  const token = TokenService.getToken();
  const fromJwt = decodeEmailFromToken(token);
  if (fromJwt) return fromJwt;
  const stored = localStorage.getItem(LOGIN_EMAIL_KEY);
  return typeof stored === 'string' ? stored.toLowerCase().trim() : '';
}

export function isAdminSession() {
  return getSessionEmail() === ADMIN_EMAIL.toLowerCase();
}
